import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ADUCApp from './components/aduc/ADUCApp';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ADUCApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
